import { useEffect } from "react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import LandingProvider from "./Context/index"
import "./Global.css"
import Routes from "./Routes"
import fireload from "./Services/firebaseConection"

function App() {
  useEffect(() => {
    fireload()
  }, [])

  return (
    <LandingProvider>
      <ToastContainer autoClose={3000} />
      <Routes />
    </LandingProvider>
  )
}

export default App
